import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSignDark = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 14 15",
	style: { enableBackground: "new 0 0 14 15" },
	xmlSpace: "preserve",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M8,0.9c1-1,2.5-1,3.5,0c1,1,1,2.5,0,3.5l-0.3,0.3l0.1,0.1c0.8,0.8,0.8,2,0,2.8L9.9,9C9.7,9.2,9.3,9.2,9.1,9 C9,8.8,9,8.5,9.1,8.3l1.4-1.4c0.4-0.4,0.4-1,0-1.4l-0.1-0.1L4.9,11c-0.1,0.1-0.1,0.1-0.2,0.1l-4,1c-0.2,0-0.4,0-0.5-0.1 C0,11.8,0,11.6,0,11.5l1.3-3.7c0-0.1,0.1-0.1,0.1-0.2L8,0.9z M10.8,1.6c-0.6-0.6-1.5-0.6-2,0L2.2,8.1l-0.9,2.8l3-0.7l6.5-6.5 C11.3,3.1,11.3,2.2,10.8,1.6z" }),
		/* @__PURE__ */ _jsx("path", { d: "M4,14.1c-1.2,0-2.2-0.6-2.9-1.1l1.3-0.3c0.4,0.2,1,0.4,1.6,0.4c0.4,0,0.8-0.2,1.3-0.5c0.4-0.3,0.9-0.7,1.3-1.1l0.1-0.1 c0.4-0.4,0.8-0.7,1.2-1c0.4-0.3,0.9-0.5,1.5-0.3c0.4,0.1,0.6,0.4,0.8,0.7c0.2,0.3,0.3,0.7,0.4,1.1c0,0.2,0.1,0.4,0.2,0.5 c0,0.1,0.1,0.1,0.1,0.1c0,0,0,0,0,0c0.1,0,0.3-0.1,0.6-0.3c0.2-0.1,0.3-0.3,0.5-0.4c0.1-0.1,0.2-0.2,0.3-0.2 c0.3-0.2,0.5-0.3,0.7-0.4c0.1,0,0.2-0.1,0.2-0.1c0,0,0,0,0.1,0l0,0l0,0l0,0l0,0c0,0,0,0,0.2,0.5l-0.2-0.5c0.3-0.1,0.5,0.1,0.6,0.3 c0.1,0.3-0.1,0.5-0.3,0.6l0,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0.1c-0.1,0.1-0.3,0.2-0.5,0.3c-0.1,0-0.1,0.1-0.2,0.2 c-0.2,0.1-0.4,0.3-0.6,0.5c-0.3,0.2-0.7,0.5-1.2,0.5c-0.4,0-0.8-0.3-0.9-0.5c-0.2-0.3-0.3-0.6-0.4-0.9c-0.1-0.4-0.2-0.7-0.3-0.9 c-0.1-0.2-0.2-0.2-0.3-0.3c-0.1,0-0.2,0-0.6,0.2c-0.3,0.2-0.7,0.5-1.1,0.9l-0.1,0.1c-0.4,0.4-0.9,0.9-1.4,1.2 C5.3,13.8,4.6,14.1,4,14.1z" })
	]
});
const ForwardRef = forwardRef(SvgSignDark);
export default ForwardRef;
